import React from 'react';
interface StatusPillProps {
  status: 'open' | 'closing-soon' | 'closed' | 'awarded' | 'active' | 'completed';
  children: React.ReactNode;
}
export function StatusPill({
  status,
  children
}: StatusPillProps) {
  const statusStyles = {
    open: 'bg-au-green-light text-au-green',
    'closing-soon': 'bg-amber-100 text-amber-800',
    closed: 'bg-gray-200 text-gray-700',
    awarded: 'bg-au-green-light text-au-green',
    active: 'bg-blue-100 text-blue-800',
    completed: 'bg-gray-200 text-gray-700'
  };
  return <span className={`inline-block rounded-full px-3 py-1 text-xs font-medium ${statusStyles[status]}`} data-id="element-377">
      {children}
    </span>;
}